import { Filter } from '@anytag/shared-molecules';
import { FilterAction } from '@anytag/shared-types';
import { Template, TemplateProps } from './Template';
import { TikTokCampaignPostsFilterFormValues } from './schemaTypes';

export type TikTokCampaignPostsFilterProps = FilterAction<TikTokCampaignPostsFilterFormValues> &
  Omit<TemplateProps, 'onSubmit'>;

export const TikTokCampaignPostsFilter = ({ filter, setFilter, ...templateProps }: TikTokCampaignPostsFilterProps) => (
  <Filter.Provider onSubmit={setFilter} values={filter}>
    <Template {...templateProps} />
  </Filter.Provider>
);

export * from './schemaTypes';
